import FaqComponent from "../../components/FAQ/FaqComponent";

export default function FAQ() {

    return (
        <FaqComponent />
    )
}